import React, { useEffect, useMemo, useState } from "react"
// import "../Transactions/salesinvoice.scss"
import axios from "../../axios"
import moment from "moment"
import numeral from "numeral"
import SweetAlert from "react-bootstrap-sweetalert"
import Select from "react-select"

import toastr from "toastr"
import "toastr/build/toastr.min.css";
import { makeStyles } from "@material-ui/core/styles"
import Spinner from "react-spinkit"
// import { Tooltip } from "@material-ui/core"
import Backdrop from "@material-ui/core/Backdrop"
// import Breadcrumbs from "../../components/Common/Breadcrumb"
// import DeleteModal from "../../components/Common/DeleteModal"
// import TableRows from "../../components/Common/TableRows"
// import TableContainer from "../../components/Common/TableContainer"
import { Link } from "react-router-dom"
import { useHistory } from "react-router-dom"
import { saveAs } from "file-saver"
import Switch from "react-switch"
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  CardTitle,
  ModalHeader,
  ModalBody,
  Form,
  Card,
  Input,
  Container,
  // Table,
  Label,
  CardBody,
  Button,
  ModalFooter,
} from "reactstrap"
import {
  Divider, Tooltip, TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow, Table,
  TableBody,
  TextField, InputAdornment
} from "@material-ui/core"
import { Button as CustomButton2 } from "@mui/material"
import { styled } from "@mui/system"

import { set } from "lodash"
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  dialogpaper: {
    width: "1200px",
  },
}))



const CustomButton = styled(Button)({
  boxShadow: 0,
  marginLeft: 5,
  backgroundColor: "#3468C0",
  color: "#yourCustomTextColor",
  "&:hover": {
    backgroundColor: "#2c3e50",
  },
})

function TaxMaster() {
  const [Active1, setActive1] = useState(true)

  const [modal, setModal] = useState(false)

  const [Active, setActive] = useState(true)

  const [deletemsg, setdeletemsg] = useState(false)

  const [Department, setDepartment] = useState("")
  const [description, setdescription] = useState("")

  const [tokent, settokent] = useState(
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
  )
  const [CityMasterData, setCityMasterData] = useState([])
  // const [CityMasterData, setCityMasterData] = useState([])
  const history = useHistory()
  const [deleteModal, setDeleteModal] = useState(false)
  const [deletid, setdeletid] = useState("")
  const [deletepopup, setdeletepopup] = useState(false)
  const [dailoa1, setdailoa1] = useState(false)
  const classes = useStyles()

  const [edit, setedit] = useState(false)
  const [Departmentid, setDepartmentid] = useState("")
  //err
  const [CityNameerr, setCityNameerr] = useState(false)
  const [DescriptionNameErr, setDescriptionNameErr] = useState(false)

  const [added, setadded] = useState(false)
  const [duplicateerr, setduplicateerr] = useState(false)

  const [updated, setupdated] = useState(false)

  const [percentage, setpercentage] = useState("")
  const [cityid, setcityid] = useState("")

  const [TaxId, setTaxId] = useState("")


  const pages = [
    5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 150, 200, 250, 300, 400, 500,
    600, 700, 800, 900, 1000,
  ];
  const [page, setpage] = useState(0);
  const [rowsperpage, setrowsperpage] = useState(pages[page]);

  const [deletedconfirm, setdeletedconfirm] = useState(false);

  useEffect(() => {
    GetAllTax1(Active1)
  }, [])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setActive(true)
      setpercentage("")
      setdescription("")
      setedit(false)
    } else {
      setModal(true)
      setpercentage("")
      setedit(false)
      setdescription("")
    }
  }

  const getFinancialYear = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Months are zero-based
  
    let startYear, endYear;
  
    // Assuming the financial year starts in April and ends in March
    if (currentMonth >= 4) {
      startYear = currentYear;
      endYear = currentYear + 1;
    } else {
      startYear = currentYear - 1;
      endYear = currentYear;
    }
  
    return `${startYear} - ${endYear}`;
  };
  
  // console.log(getFinancialYear()); // Example Output: "2024 - 2025"
  sessionStorage.setItem("Finalyear", getFinancialYear());
  

  const [noRecords, setnoRecords] = useState(false)

  useEffect(() => {
    GetAllTax1(Active1)
  }, [Active1])


  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setrowsperpage(parseInt(event.target.value, 10));
    // setpage(0);
  };

  const changepage = () => {
    return CityMasterData.slice(
      page * rowsperpage,
      (page + 1) * rowsperpage,
    );
  };

  const GetAllTax = async () => {
    setdailoa1(true)
    const get = await axios.instance
      .get(`/GetAllTaxdata/${"Y"}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        setCityMasterData(res.data)
      })
    setTimeout(() => {
      setdailoa1(false)
    }, 1000)
  }

  const GetAllTax1 = async id => {
    setdailoa1(true)
    const get = await axios.instance
      .get(`/GetAllTaxdata/${id === true ? "Y" : "N"}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        if (data.length > 0) {
          setCityMasterData(res.data)
        } else {
          setActive1(true)
          setnoRecords(true)
        }
      })
    setTimeout(() => {
      setdailoa1(false)
    }, 1000)
  }

  const editquotation = col => {
    toggle()
    setedit(true)
    setpercentage(col.tax_percentage)
    setTaxId(col.tax_id)
    setdescription(col.tax_description)
    setActive(col.active === "N" ? false : true)
  }

  const toggledeletemodal = id => {
    setDeleteModal(true)
    setdeletid(id)
  }

  const Deletequotation = async () => {
    const get1 = await axios.instance
      .post(
        `/InsertTaxData`,
        {
          Tax_Id: deletid,
          Optype: "Delete",
        },
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      )
      .then(res => {
        const data = res.data

        // for(const i of data){
        // setid(i.Brand_Id)
        if (data === "") {
          setDeleteModal(false)
          setdeletepopup(true)
          GetAllTax1(Active1)
        } else {
          setDeleteModal(false)
          setdeletemsg(true)
        }
        // }
      })
  }

  // const GetQuotationPrint = async(id) => {

  //     const InvoicePrint= await axios.instance.get(`/GetQuotationPrint/${id}/${7}/${sessionStorage.getItem('Companyid')}/${sessionStorage.getItem('WebCal')}`,{ headers: {'Authorization':tokent,
  //     'Content-Type': 'application/json',

  //     }}).then(async(res) => {
  //         const downloadprogress =  await axios.instance.get('/GetQuotation',{ responseType: 'blob'}).then((res) => {
  //             const pdfBlob = new Blob([res.data] ,{type: 'application/pdf'})
  //             saveAs(pdfBlob, "Quotation.pdf")

  //      })
  //     })
  // }

  const Getonebrand = async id => {
    const get = await axios.instance
      .get(`/Getonebrandfilter1/${id}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        for (const data of res.data) {
          // setDescription(data.Brand)
          setActive(data.Active === "Y" ? true : false)
        }
      })
  }

  const columns = useMemo(
    () => [
      {
        Header: "Tax_Description",
        accessor: "tax_description",
        disableFilters: true,
        filterable: false,
      },
      // {
      //   Header: "Tax_Code",
      //   accessor: "tax_code",
      //   disableFilters: true,
      //   filterable: false,
      // },
      {
        Header: "Tax_Percentage",
        accessor: "tax_percentage",
        disableFilters: true,
        filterable: false,
      },
      // {
      //   Header: "Tax_Type",
      //   accessor: "tax_type",
      //   disableFilters: true,
      //   filterable: false,
      // },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex justify-content-center align-items-center gap-2">
              {/* edit icon */}
              <Tooltip title="Edit" placement="left-start">
                <Link
                  to="#"
                  className="text-primary"
                  onClick={() => {
                    const po = cellProps.row.original
                    editquotation(po)
                  }}
                >
                  <i
                    className="uil uil-pen font-size-18"
                    id="edittooltip"
                    style={{ color: "blue" }}
                  />
                </Link>
              </Tooltip>

              {/* delete icon */}
              <Tooltip title="Delete" placement="right-end">
                <Link
                  to="#"
                  className="text-danger"
                  onClick={() => {
                    if (
                      JSON.parse(sessionStorage.getItem("MenuItemTaxControls")).Del ==
                      "Y"
                    ) {
                      const po = cellProps.row.original
                      toggledeletemodal(po.tax_id)
                    } else {
                      toastr.warning(
                        "Please Contact Admin",
                        "Operation Not Allowed"
                      )
                    }
                  }}
                >
                  <i
                    className="uil uil-trash-alt font-size-18"
                    id="deletetooltip"
                  />
                </Link>
              </Tooltip>
            </div>
          )
        },
      },
    ],
    []
  )

  const InsertTaxMasterData = async () => {
    if (edit === false) {
      if (percentage.length != "" && description.length != "") {
        const get1 = await axios.instance
          .post(
            `/InsertTaxData`,
            {
              // DEPARTMENT_Id:0 ,
              // DEPARTMENT_Code:0,
              // DEPARTMENT_Description:Department,
              // Created_By:1,
              // Created_Date:moment(new Date()).format('YYYY-MM-DD'),
              // Modify_By:0,
              // Modify_Date:moment(new Date()).format('YYYY-MM-DD'),
              // Optype:"new",

              Tax_Id: "",
              Tax_Description: description,
              Tax_Code: "",
              Tax_Percentage: percentage,
              Created_By: 1,
              Created_Date: moment(new Date()).format("YYYY-MM-DD"),
              Sales: "N",
              Purchase: "N",
              Modify_By: 1,
              Modify_Date: moment(new Date()).format("YYYY-MM-DD"),
              Active: Active === true ? "Y" : "N",
              Fiscal_Year: sessionStorage.getItem("Finalyear"),
              Tax_Type: "V",
              Optype: "New",
              Comp_Id: sessionStorage.getItem("Companyid"),
              LedgerId: 0,
            },
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          .then(res => {
            if (res.data === "") {
              setpercentage("")
              setdescription("")
              toggle()
              setadded(true)
              GetAllTax1(Active1)
            } else {
              setduplicateerr(true)
            }
          })
      } else {
        if (percentage.length === 0) {
          setCityNameerr(true)
        }

        if (description.length === 0) {
          setDescriptionNameErr(true)
        }
        setTimeout(() => {
          setCityNameerr(false)
          setDescriptionNameErr(false)
        }, 2000)
      }
    } else {
      if (percentage.length != "" && description.length != "") {
        const get1 = await axios.instance
          .post(
            `/InsertTaxData`,
            {
              // DEPARTMENT_Id:0 ,
              // DEPARTMENT_Code:0,
              // DEPARTMENT_Description:Department,
              // Created_By:1,
              // Created_Date:moment(new Date()).format('YYYY-MM-DD'),
              // Modify_By:0,
              // Modify_Date:moment(new Date()).format('YYYY-MM-DD'),
              // Optype:"new",

              Tax_Id: TaxId,
              Tax_Description: description,
              Tax_Code: "",
              Tax_Percentage: percentage,
              Created_By: 1,
              Created_Date: moment(new Date()).format("YYYY-MM-DD"),
              Sales: "N",
              Purchase: "N",
              Modify_By: 1,
              Modify_Date: moment(new Date()).format("YYYY-MM-DD"),
              Active: Active === true ? "Y" : "N",
              Fiscal_Year: sessionStorage.getItem("Finalyear"),
              Tax_Type: "V",
              Optype: "Edit",
              Comp_Id: sessionStorage.getItem("Companyid"),
              LedgerId: 0,
            },
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          .then(res => {
            if (res.data === "") {
              setpercentage("")
              setdescription("")
              toggle()
              setupdated(true)
              GetAllTax1(Active1)
            } else {
              setduplicateerr(true)
            }
          })
      } else {
        if (percentage.length === 0) {
          setCityNameerr(true)
        }

        if (description.length === 0) {
          setDescriptionNameErr(true)
        }
        setTimeout(() => {
          setCityNameerr(false)
          setDescriptionNameErr(false)
        }, 2000)
      }
    }
  }

  return (
    <React.Fragment>
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={() => Deletequotation()}
        onCloseClick={() => setDeleteModal(false)}
      /> */}

      <div className="page-content" style={{ backgroundColor: "inherit" }}>
        <div className="">
          <Row>
            <Col xs="12">
              <h6 className="titleviewinspections">Tax Master</h6>
              <Card>
                <CardBody>
                  <div>
                    {/* <Breadcrumbs title="Master" breadcrumbItem="Tax Master" /> */}
                  </div>
                  <Divider sx={{ mb: 2 }} />
                  <div className="d-flex justify-content-end align-items-center mt-3">
                    <Col
                      xl={12}
                      className="d-flex justify-content-end gap-2 align-items-center"
                    >
                      <div
                        className="d-flex d-flex-column gap-2 justify-content-end align-items-center pr-2"
                        style={{
                          borderRight: "1px solid #61677A",
                          paddingRight: "10px",
                        }}
                      >
                        <h5 className="font-size-14 mt-1">Active Tax</h5>
                        <div className="mt-2 ml-2">
                          <Switch
                            onChange={checked => {
                              {
                                checked ? setActive1(true) : setActive1(false)
                              }

                              GetAllTax1(checked)
                            }}
                            checked={Active1}
                            width={40}
                            height={20}
                          />
                        </div>
                      </div>
                      <CustomButton
                        variant="contained"
                        onClick={() => {
                          // if (
                          //   JSON.parse(sessionStorage.getItem("MenuItemTaxControls"))
                          //     .New == "Y"
                          // ) {
                          toggle()
                          // } else {
                          //   toastr.warning(
                          //     "Please Contact Admin",
                          //     "Operation Not Allowed"
                          //   )
                          // }
                        }}
                        size="small"
                      >
                        Add Tax
                      </CustomButton>
                    </Col>
                  </div>
                  {/* <TableContainer
                    columns={columns}
                    data={CityMasterData}
                    isGlobalFilter={true}
                    isAddOrder={true}
                    isAddTableWithoutBorderStrap={true}
                  /> */}
                  <div>
                    {/* <Card className="">
                        <CardBody> */}
                    <div className="Tabelinspections">
                      <TableContainer>
                        <Table className="InspectionTbls">
                          <TableHead>
                            <TableRow>
                              <TableCell>Tax Description </TableCell>
                              <TableCell align="left">Tax Percentage</TableCell>
                              <TableCell>Edit</TableCell>
                              <TableCell>Delete</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {CityMasterData.length != 0 ? (
                              changepage().map((data, index) => (
                                <TableRow key={index}>
                                  <TableCell style={{ textAlign: "left" }}>
                                    {data.tax_description}
                                  </TableCell>
                                  <TableCell style={{ textAlign: "center" }}>
                                    {data.tax_percentage}
                                  </TableCell>

                                  <TableCell align="left">
                                    <IconButton size="small">
                                      {/* <VisibilityIcon fontSize="small"  */}
                                      <EditIcon
                                        fontSize="small"
                                        color="primary"
                                        onClick={() => {
                                          // editdata(data);
                                          console.log(data);
                                          // setdeleteid(data.Termsid);
                                          // setisedit(true);
                                          editquotation(data)
                                        }}
                                      />
                                    </IconButton>
                                  </TableCell>
                                  <TableCell align="left">
                                    <IconButton size="small">
                                      <DeleteIcon
                                        color="error"
                                        fontSize="small"
                                        onClick={() => {
                                          // setdeletedconfirm(true);
                                          // setdeleteid(data.Termsid);
                                          setdeletedconfirm(true);
                                          // toggledeletemodal(data.branch_id)
                                          setdeletid(data.tax_id)
                                        }}
                                      />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableCell align="left">NO Data Found</TableCell>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <TablePagination
                        component="div"
                        rowsPerPageOptions={pages}
                        count={CityMasterData.length}
                        rowsPerPage={rowsperpage}
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                      />
                    </div>
                    {/* <Backdrop open={open}>
                            <Spinner name="ball-spin-fade-loader" color="#fafafa" />
                            <p style={{ marginTop: '50px' }}></p>
                          </Backdrop> */}
                    {/* </CardBody>
                      </Card> */}

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle} size="lg">
            <ModalHeader
              toggle={() => {
                toggle()
                setedit(false)
                setdescription("")
                setpercentage("")
              }}
              tag="h4"
            >
              {edit === true ? "Edit Tax" : "Add Tax"}
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col lg="5">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Description <b className="text-danger">*</b>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={description}
                      // disabled
                      onChange={e => {
                        setdescription(e.target.value)
                      }}
                    />
                    {DescriptionNameErr == true ? (
                      <p style={{ color: "red", fontSize: "12px" }}>
                        Please Enter Description
                      </p>
                    ) : null}
                  </div>
                </Col>
                <Col lg="5">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Percentage (%) <b className="text-danger">*</b>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="Number"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      value={percentage}
                      onChange={e => {
                        // setDepartment(e.target.value)
                        setpercentage(e.target.value)
                      }}
                    />
                    {CityNameerr == true ? (
                      <p style={{ color: "red", fontSize: "12px" }}>
                        Please Enter Percentage
                      </p>
                    ) : null}
                  </div>
                </Col>
                <Col lg="2">
                  <h5 className="font-size-14 mt-1">Active</h5>
                  <div className="mt-3">
                    <Switch
                      onChange={checked => {
                        {
                          checked ? setActive(true) : setActive(false)
                        }
                      }}
                      checked={Active}
                      width={40}
                      height={20}
                    />
                  </div>
                </Col>
              </Row>
              {/* <Row>
               
            </Row> */}
              <ModalFooter>
                {edit === false ? (
                  <Button
                    style={{ backgroundColor: "#3468C0", color: "white" }}
                    color="primary"
                    onClick={() => {
                      InsertTaxMasterData().then(() => {
                        setActive1(true)
                      })
                      toggle()
                    }}
                  >
                    Save
                  </Button>
                ) : (
                  <Button
                    style={{ backgroundColor: "#3468C0", color: "white" }}
                    color="primary"
                    onClick={() => {
                      // if (
                      //   JSON.parse(sessionStorage.getItem("MenuItemTaxControls"))
                      //     .Edit == "Y"
                      // ) {
                        InsertTaxMasterData().then(() => {
                          setActive1(true)
                        })
                        toggle()
                      // } else {
                      //   toastr.warning(
                      //     "Please Contact Admin",
                      //     "Operation Not Allowed"
                      //   )
                      // }
                    }}
                  >
                    Update
                  </Button>
                )}
              </ModalFooter>
            </ModalBody>
          </Modal>
        </div>
      </div>



      <Backdrop open={dailoa1} className={classes.backdrop}>
        <Spinner name="ball-spin-fade-loader" color="#fafafa" />
      </Backdrop>

      {deletepopup ? (
        <SweetAlert
          title="Tax Deleted Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setdeletepopup(false)
          }}
        ></SweetAlert>
      ) : null}

      {deletemsg ? (
        <SweetAlert
          title="Transaction Found Can't Be Delete This Record"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setdeletemsg(false)
          }}
        ></SweetAlert>
      ) : null}

      {added ? (
        <SweetAlert
          title="Tax Added Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setadded(false)
          }}
        ></SweetAlert>
      ) : null}

      {updated ? (
        <SweetAlert
          title="Tax Updated Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setupdated(false)
          }}
        ></SweetAlert>
      ) : null}

      {duplicateerr ? (
        <SweetAlert
          title="Percentage  Already Exist"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setduplicateerr(false)
          }}
        ></SweetAlert>
      ) : null}

      {noRecords ? (
        <SweetAlert
          title="No Records Found for InActive"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          warning
          onConfirm={() => {
            setnoRecords(false)
          }}
        ></SweetAlert>
      ) : null}

      {deletedconfirm ? (
        <SweetAlert
          title="Are You Sure?"
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          confirmBtnBsStyle="success"
          showConfirm={true}
          cancelBtnBsStyle="danger"
          cancelBtnText="Cancel"
          confirmBtnText="Yes,delete it!"
          showCancel={true}
          warning
          onConfirm={() => {
            Deletequotation();
            setdeletedconfirm(false);
          }}
          onCancel={() => {
            setdeletedconfirm(false);
            // setdeleted(false);
          }}
        >
          <p style={{ fontSize: '20px' }}>You Won't able to revert this!</p>
        </SweetAlert>
      ) : null}
    </React.Fragment>
  )
}

export default TaxMaster

//postman

// "Tax_Id":0,
// "Tax_Description":"ssdv",
// "Tax_Code":"",
// "Tax_Percentage":"1.00",
// "Created_By":1,
// "Created_Date":"20231209",
// "Sales":"N",
// "Purchase":"N",
// "Modify_By":1,
// "Modify_Date":"20231209",
// "Active":"Y",
// "Fiscal_Year":"2023 - 2024",
// "Tax_Type":"V",
// "Optype":"New",
// "Comp_Id":2,
// "LedgerId":0
